import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  CreateAccount,
  RegisterCompany
} from '@app/pages/signup/models/signup.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  private readonly accountApiUrl = environment.accountApi;

  constructor(private http: HttpClient) {}

  public createSupplierUser(body: CreateAccount): Observable<any> {
    return this.http.post<any>(
      `${this.accountApiUrl}/signup/supplier/user`,
      body
    );
  }

  public createCompanySupplier(body: RegisterCompany): Observable<any> {
    return this.http.post<any>(
      `${this.accountApiUrl}/signup/company/supplier`,
      body
    );
  }

  public getSignupInstructions(): Observable<string> {
    return this.http.get<string>(
      `${this.accountApiUrl}/signup/getInstructionFile`
    );
  }
}
